module.exports = __webpack_public_path__ + "static/media/face_verysad.46f10d94.svg";